<script>
import Layout from "@layouts/form";
import Consultor from "@forms/Consultor";

export default {
  page: {
    title: "Detalhes | Consultor"
  },
  components: { Layout, Consultor },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Consultor",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Consultor",
          href: "/Consultor"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <Consultor :editable="editable"></Consultor>
    </div>
  </Layout>
</template>
